import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BlogListProvider } from "./pages/blog/BlogList";
import { WorkListProvider } from "./pages/work/WorkList";

ReactDOM.render(
  <React.StrictMode>
    {/* Provide Global Access To Blog and Work Providers */}
    <BlogListProvider>
      <WorkListProvider>
        <App />
      </WorkListProvider>
    </BlogListProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
